import { mount } from 'svelte';
import '../shared/styles/fonts.css';
import '../shared/styles/palettes.css';
import '../shared/styles/base.css';
import App from './App.svelte';

const target = document.getElementById('app');
if (!target) throw new Error('Missing #app');

export default mount(App, { target });
